import { render, staticRenderFns } from "./AppLoginRouter.vue?vue&type=template&id=f623d602"
import script from "./AppLoginRouter.vue?vue&type=script&lang=js"
export * from "./AppLoginRouter.vue?vue&type=script&lang=js"
import style0 from "./AppLoginRouter.vue?vue&type=style&index=0&id=f623d602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports